import { MinzeElement, Reactive, EventListeners } from 'minze'
import { Font, config } from '../../constants'
import MainModule from '../../modules/main'

export interface LvcBanner {}

export class LvcBanner extends MinzeElement {
  reactive: Reactive = [
    ['isDesktop', true],
    ['showBanner', false],
    ['bannerText', ''],
    ['buttonLabel', ''],
    ['buttonLink', ''],
  ]

  private boundTextLoaded = this.onTextLoaded.bind(this)

  onTextLoaded() {
    let lang = MainModule.getInstance().getLocale().getLanguage()
    let bannerData = localStorage.getItem('bannerData')
    this.rerender()
    if (bannerData) {
      let data = JSON.parse(bannerData)
      this.showBanner = data.value[0].displayOnSite[lang]
      this.bannerText = data.value[0].text[lang]
      this.buttonLabel = data.value[0].linkText[lang]
      this.buttonLink = data.value[0].link[lang]
    }
  }

  onReady(): void | Promise<void> {
    this.onTextLoaded()

    MainModule.getInstance().getEE().on('lvc:squidex_labels_loaded', this.boundTextLoaded)

    if (sessionStorage.getItem('showBanner') === 'false') {
      this.remove()
    }

    // var width = window.innerWidth > 0 ? window.innerWidth : screen.width;

    // this.isDesktop = width > 960;
  }

  onDestroy(): void | Promise<void> {
    MainModule.getInstance().getEE().off('lvc:squidex_labels_loaded', this.boundTextLoaded)
  }

  onClickButton() {
    this.remove()
    sessionStorage.setItem('showBanner', 'false')
  }

  html = () => `
    <div class="banner-wrapper">  
      <div class="content-wrapper">   
        <lvc-text class="banner-title" font-preset="titleMobileSmall" line-height="1.2">${this.bannerText}</lvc-text>
        <a class="details-button" href="${this.buttonLink}" target="_blank">
					${this.buttonLabel}
					<lvc-arrow-right-icon width="44" height="44"></lvc-arrow-right-icon>
        </a>
      </div>
			<div class="close-button">
				<lvc-close-icon width="17" height="17"></lvc-close-icon>
			</div>
    </div>
  `

  css = () => `
  	:host{
    	${!this.showBanner ? ` display:none;` : ``}
	 	}
		.banner-wrapper {
			position: relative;
			width: 100%;
			background-color: #FF4600;
			padding: 18px 48px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			gap: 40px;
    }
		.content-wrapper {
			display: flex;
			flex-direction: row;
			flex-grow: 1;
			align-content: center;
			align-items: center;
			gap: 40px;
		}
		.close-button {
			padding: 4px;
			cursor: pointer;
			margin-top: 1px;
    }
		lvc-close-icon {
			display: flex;
		}
    .details-button {
			display: flex;
			font-weight: ${Font.weight.medium};
			font-size: 14px;
			line-height:16.8px;
			font-family: ${Font.family};
			color: #1E007D;
			text-decoration: none;
			gap: 10px;
			align-items: center;
    }
		
		@media only screen and (max-width: 991px) {
			.banner-wrapper {
				padding: 1rem;
				padding-bottom: 0.5rem;
			}
			.content-wrapper {
				flex-direction: column;
				gap: 0px;
				align-items: flex-start;
				padding-right: 2rem;
			}
			.banner-title::part(text) {
				font-size: 1.2rem!important;
			}
			.close-button {
				position: absolute;
				top: 0.5rem;
				right: 0.5rem;
			}
			lvc-arrow-right-icon {
				width: 32px;
				height: 32px;
			}
		}
	`
  eventListeners: EventListeners = [['.close-button', 'click', this.onClickButton.bind(this)]]
}
